export default {"src":"/_next/static/media/lesdeux.b48caf86.svg","height":80,"width":184,"blurWidth":0,"blurHeight":0};